/* This class represents a lead of type Information for a plan. */
export default class PlanInformationLead {
    constructor(formData) {
      this.planId = formData.id;
      this.comments = formData.comments;
      this.includeRecommendations = formData.includeRecommended;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.type = 'postPlanBrochure';
      this.userPhoneNumber = formData.phone;
      this.leadAction = formData.leadAction;
      this.fromPage = formData.fromPage;
      this.excludeRecommendations = formData.excludeRecommendations;
      this.realtorQuestionAnswerId = formData.realtorQuestion;
      this.guid = formData.guid;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }

    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
      this.builderName = properties.brandName;
      this.communityName = properties.communityName;
      this.communityId = properties.communityId;
      this.wasMatchedAsSpotlightResult = properties.wasMatchedAsSpotlightResult;
      this.spotlightResultPosition =
        properties.wasMatchedAsSpotlightResult === 'true' ? Number(properties.index) + 1 : null;
    }
  }
  